<template>
  <div class="relative z-10 flex flex-shrink-0 h-16 bg-white shadow">
    <button
      @click="$emit('sidebar:open')"
      class="px-4 text-gray-500 border-r border-gray-200 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden"
    >
      <svg
        class="w-6 h-6"
        stroke="currentColor"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 12h16M4 18h7"
        />
      </svg>
    </button>

    <div class="flex items-center justify-between flex-1 px-4">
      <div class="flex w-full md:ml-0">
        <h1 class="text-2xl font-semibold text-gray-900">
          {{ $route.meta.title || 'Happer' }}
        </h1>
      </div>

      <div class="flex items-center ml-4 md:ml-6">
        <button
          class="p-1 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:shadow-outline focus:text-gray-500"
        >
          <svg
            class="w-6 h-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
        </button>

        <button
          @click="$emit('navbar:close')"
          tabindex="-1"
          v-if="isOpen"
          class="fixed inset-0 w-full h-full cursor-default"
        ></button>

        <div class="relative ml-3">
          <div>
            <button
              @click="$emit('navbar:toggle')"
              class="flex items-center max-w-xs text-sm rounded-full focus:outline-none focus:shadow-outline"
            >
              <img
                class="w-8 h-8 rounded-full"
                :src="require('../assets/images/noavatar.png')"
                alt=""
              />
            </button>
          </div>

          <transition
            enter-class="transition duration-100 ease-out"
            enter-from-class="scale-95 opacity-0"
            enter-to-class="scale-100 opacity-100"
            leave-class="transition duration-75 ease-in"
            leave-from-class="scale-100 opacity-100"
            leave-to-class="scale-95 opacity-0"
          >
            <div
              v-show="isOpen"
              class="absolute right-0 w-48 mt-2 origin-top-right transform rounded-md shadow-lg"
            >
              <div class="py-1 bg-white rounded-md shadow-xs">
                 <router-link
                  :to="{ name: 'Profile' }"
                  class="block px-4 py-2 text-sm text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100"
                  >Perfil
                </router-link>

                <a
                  @click="logout"
                  href="#"
                  class="block px-4 py-2 text-sm text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100"
                  >Cerrar sesión</a
                >
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logout } from '@/auth.js'

export default {
  props: {
    isOpen: { type: Boolean, required: true },
  },

  methods: {
    logout() {
      logout().then(() => this.$router.push('/'))
    },
  },
}
</script>
